import { Box, styled } from '@mui/material';

export const RootBox = styled(Box)`
    padding: 48px 96px;
`;
export const SkillsRatingWrapper = styled('div')({
    marginRight: '50px',
    marginLeft: '30px',
    marginTop: '50px'
});
